import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';

const styles = (theme) => ({
  inputContainer: {
    backgroundImage: 'linear-gradient(to top right, #166b8c, #1d5267)',
    borderTop: '1px solid ' + theme.palette.hr.main,
  },
});

const InputContainer = ({ classes, children }) => (
  <div className={classes.inputContainer}>{children}</div>
);
InputContainer.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
};

export default withStyles(styles)(InputContainer);
